import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Hotel } from '../../../../components/home/home-our-properties/home-our-properties.component';

@Component({
  selector: 'app-upcoming-property-card',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './upcoming-property-card.component.html',
  styleUrl: './upcoming-property-card.component.scss',
})
export class UpcomingPropertyCardComponent {
  @Input() hotel!: any;
  @Input() type: 'regular' | 'upcoming' = 'regular';
 
}
